<template>
  <div class="item" @click="showModal">
    <div class="bg-norepeat bg-cover fill-parent" v-lazy:background-image="product.PhotoUrl"></div>
    <div class="rectangle-row" style="height:130px">
      <div class="col-sm-11 col-md-8 col-xl-8 mt-3 pl-2">
        <div
          :class="{ 'gift-with-image': product.PhotoUrl }"
          class="item-details gift-detail"
          style="padding:0"
        >
          <h5 class="item-title">{{ category.Name | camelCase }}</h5>
          <p
            class=""
            :class="{'g-p-h':product.ShortDescription}"
            v-html="product.ShortDescription"
          ></p>
        </div>
        <div class="product-price" style="color:black;">{{ category.Price | formatMoney(currencySign) }}</div>
      </div>
      <div
        :class="{
          new: product.Status == 1,
          popular: product.Status == 2,
          sold: product.Status == 3
        }"
        class="ibadge"
      >{{ product.Status | formatStatus(this) }}</div>
      <details-popup
        v-if="isModalVisible"
        :price="category.Price"
        :product-id="category.ProductID"
        :product="product"
      />
    </div>
  </div>
</template>

<script>
// import AddToCart from "./AddToCart";
import shared from "../../../sharedscripts/shop/products/Product.js";
import DetailsPopup from "./GiftAddToCart.vue";
export default {
  name: "Product",
  components: { DetailsPopup },
  filters: {
    ...shared.filters
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    category: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isModalVisible: false
    };
  },
  computed: {
    ...shared.computed,
  },
  watch: {
    isModalVisible() {}
  },
  methods: {
    ...shared.methods
  }
};
</script>
